var _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliders = function SvgSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H10",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H13",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 4,
    r: 1.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H5",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H8",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8,
    r: 1.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H8",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H11",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 12,
    r: 1.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })));
};
export default SvgSliders;